import React from "react";

import { Button } from "@mui/material";

export const AddFilesButton: React.FC<{ onLoadFiles: (files: File[]) => void }> = ({ onLoadFiles }) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      onLoadFiles(Array.from(e.target.files));
      // Clear the input value to allow the same file to be selected again
      e.target.value = "";
    }
  };

  return (
    <Button sx={{ backgroundColor: "#0a3142" }} component="label" variant="contained">
      Upload PDF
      <input type="file" accept="application/pdf" multiple hidden={true} onChange={onChange} />
    </Button>
  );
};
